<div class="toaster--container">
  <div
    *ngFor="let message of messages"
    class="toaster--item"
    [class.toaster--success]="message.type === 'success'"
    [class.toaster--error]="message.type === 'error'"
    [class.toaster--warning]="message.type === 'warning'"
    [class.toaster--info]="message.type === 'info'"
    [@slideIn]
  >
    <div class="toaster--content">
      <!-- Icon -->
      <div class="toaster--icon">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path [attr.d]="getIcon(message.type)"></path>
        </svg>
      </div>

      <!-- Message -->
      <div class="toaster--message">{{ message.message }}</div>

      <!-- Close Button -->
      <button
        class="toaster--close"
        (click)="dismiss(message.id)"
        aria-label="Close notification"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>

    <!-- Progress Bar (hidden when showProgress is false, e.g. during file upload) -->
    <div class="toaster--progress" *ngIf="message.duration && message.showProgress !== false">
      <div
        class="toaster--progress-bar"
        [style.animation-duration.ms]="message.duration"
      ></div>
    </div>
  </div>
</div>
